import React from 'react'
import { useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { Form, Input } from 'antd'
import { Formik } from 'formik'
import * as yup from 'yup'

import { AppUrls } from 'common/AppUrls'
import { putProfile } from 'store/actions/profile'
import { ReactComponent as MainEmailIcon } from 'assets/svg/login/main_email.svg'
import { ReactComponent as MainPasswordIcon } from 'assets/svg/login/main_password_blue.svg'
import { useTranslation } from 'react-i18next'

export const UserInfo = () => {
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const history = useHistory()
    const { contact_nickname, email, is_billing } = useSelector((state) => state.profile.data)

    const initialValues = {
        contact_nickname,
        email
    }
    const validationSchema = yup.object().shape({
        contact_nickname: yup.string().nullable(),
        email: yup.string().nullable().email(t('email_incorrect')).required(t('field_required'))
    })

    function navigateToChangePassword() {
        history.push(AppUrls.changePassword)
    }

    function onSubmit(values) {
        dispatch(putProfile({ values }))
    }

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
            enableReinitialize
        >
            {({ values, touched, errors, handleChange, handleBlur, handleSubmit }) => (
                <>
                    <div className="account__form">
                        <span className="account__title">{t('account_info')}</span>
                        <div className="account__white-box">
                            <Form.Item
                                className="account__form-item"
                                validateStatus={errors.contact_nickname ? 'error' : null}
                            >
                                <Input
                                    name="contact_nickname"
                                    value={values.contact_nickname}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    className="app__input"
                                    placeholder={t('enter_name')}
                                    prefix={<MainEmailIcon />}
                                />
                                {errors.contact_nickname && touched.contact_nickname && (
                                    <p className="account__form-error">{errors.contact_nickname}</p>
                                )}
                            </Form.Item>
                            <Form.Item className="account__form-item" validateStatus={errors.email ? 'error' : null}>
                                <Input
                                    name="email"
                                    value={values.email}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    className="app__input"
                                    placeholder={t('email')}
                                    disabled={is_billing}
                                    prefix={<MainEmailIcon />}
                                />
                                {errors.email && touched.email && <p className="account__form-error">{errors.email}</p>}
                            </Form.Item>
                        </div>
                    </div>
                    <div className="account__buttons">
                        <button type="button" onClick={navigateToChangePassword} className="account__buttons__link">
                            <MainPasswordIcon />
                            {t('change_password')}
                        </button>
                        <button type="button" onClick={handleSubmit} className="account__buttons__submit">
                            {t('update')}
                        </button>
                    </div>
                </>
            )}
        </Formik>
    )
}
